// FASE 05 — item 13/PO 2026-08-26: "apresentar uma caixa de texto para que visualmente o
// usuário saiba que os campos são para edição".
//
// O DataGrid v5 só vira editor com duplo clique, o que escondia a edição. Aqui a célula é
// sempre um campo: o usuário clica e digita. O valor é confirmado no blur (ou Enter), para
// não disparar uma gravação a cada tecla.

import React, { useEffect, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";

interface CelulaPrecoProps {
  valor: number;
  desabilitado: boolean;
  onConfirmar: (novoValor: number) => void;
}

const paraTexto = (valor: number): string =>
  Number.isFinite(valor) ? valor.toFixed(2).replace(".", ",") : "0,00";

const paraNumero = (texto: string): number | null => {
  const limpo = (texto || "").replace(/\s/g, "").replace(/\./g, "").replace(",", ".");
  if (limpo === "") return 0;
  const numero = Number(limpo);
  return Number.isFinite(numero) && numero >= 0 ? numero : null;
};

export const CelulaPreco: React.FC<CelulaPrecoProps> = ({ valor, desabilitado, onConfirmar }) => {
  const [texto, setTexto] = useState(() => paraTexto(valor));

  // Recarga da página (troca de filtro, salvar, paginação) precisa refletir no campo.
  useEffect(() => {
    setTexto(paraTexto(valor));
  }, [valor]);

  const confirmar = () => {
    const numero = paraNumero(texto);

    if (numero === null) {
      setTexto(paraTexto(valor));
      return;
    }

    setTexto(paraTexto(numero));
    if (numero !== valor) onConfirmar(numero);
  };

  return (
    <TextField
      size="small"
      variant="outlined"
      value={texto}
      disabled={desabilitado}
      onChange={(e) => setTexto(e.target.value)}
      onBlur={confirmar}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === "Enter") (e.target as HTMLInputElement).blur();
      }}
      onClick={(e) => e.stopPropagation()}
      InputProps={{
        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
      }}
      inputProps={{ style: { textAlign: "right", padding: "6px 4px" } }}
      sx={{ width: "100%", backgroundColor: desabilitado ? "transparent" : "#fff" }}
    />
  );
};
